import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  success: false,
  error: false,
  cmsData: [],
  signupData: ""
};

const cmsSlice = createSlice({
  name: "cms",
  initialState,
  reducers: {
    getCmsStart: (state, action) => {
      state.loading = true;
      if (action.payload?.isSignUpCms) {
        state.signupData = initialState.signupData;
      }
    },
    getCmsSuccess: (state, action) => {
      if (action.payload.isSignUpCms) {
        state.signupData = action.payload?.signupData;
      }
      if (!action.payload.isSignUpCms) {
        state.cmsData = action.payload;
      }
      state.loading = false;
      state.success = true;
    },
    getCmsFailure: (state, action) => {
      state.loading = false;
      state.error = true;
    }
  }
});

export const { getCmsStart, getCmsSuccess, getCmsFailure } = cmsSlice.actions;

export default cmsSlice.reducer;
